import {HTMLAttributes} from 'react';
import styled from 'styled-components';
import {Button} from '@/components/Button';
import toast from '@/components/HotToast';
import {Flexbox, FlexFullGrow} from '@/styled-components';
import {copyText} from '@/utils';

export const AddressRow = ({
  address,
  children,
  ...props
}: {address: string} & HTMLAttributes<HTMLDivElement>) => {
  const copyAddress = () => {
    const success = address && copyText(address);

    if (success) {
      toast('주소가 복사되었습니다.');
    }
  };

  if (!address?.length) {
    return null;
  }

  return (
    <AddrRow {...props}>
      <td>
        <span>주소</span>
      </td>
      <td>
        <Flexbox alignItems="baseline" onClick={copyAddress}>
          <span>{address}</span>
          <FlexFullGrow />
          <Button variant="ghost" size="medium" noPadding>
            복사
          </Button>
        </Flexbox>
        {children}
      </td>
    </AddrRow>
  );
};

const AddrRow = styled.tr`
  cursor: pointer;
  :hover {
    span {
      opacity: 0.6;
    }
    ${Button} {
      visibility: visible;
    }
  }
  ${Button} {
    visibility: hidden;
    flex-shrink: 0;
    margin-left: 12px;
    color: #1a7ad0;
  }
`;
